import {
  SitrepCardSurface,
  type SitrepViewDataProps,
} from 'components/Reports/reports.types';
import Loader from 'components/Loader/Loader';
import ReportsSitrepCard from 'components/Reports/ReportsSitrepCard';

type DraftReportViewProps = {
  draftSitreps: SitrepViewDataProps;
  derivedAorId?: string | null;
};

const DraftReportView: React.FC<DraftReportViewProps> = ({
  draftSitreps,
  derivedAorId,
}) => {
  return (
    <div className="reports-tabs">
      {draftSitreps.isError ? (
        <div className="mt-4 text-center">
          <span>Error loading reports.</span>
        </div>
      ) : !derivedAorId ? (
        <div className="mt-4 text-center">
          <span>
            Unable to determine Area of Responsibility for this incident. Please
            ensure the incident is associated with an AOR in order to create and
            view draft SITREPs.
          </span>
        </div>
      ) : draftSitreps.isLoading ? (
        <Loader />
      ) : draftSitreps.data.length > 0 ? (
        draftSitreps.data.map((sitrep) => (
          <ReportsSitrepCard
            key={sitrep.id}
            sitrep={sitrep}
            surface={SitrepCardSurface.Draft}
          />
        ))
      ) : (
        <div className="reports-tabs__header__empty">
          <p>No Draft SITREPs found</p>
        </div>
      )}
    </div>
  );
};

export default DraftReportView;
